import { DesignElement } from "@design-controls/types";
import { useMutation } from "react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { designControlsApi } from "../../api/designControls";
import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";

export const useCreateDesignElement = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const { showToast } = useToastProvider();

  return useMutation({
    mutationFn: (data: Partial<DesignElement>) =>
      designControlsApi.createDesignElement(companyId, productId, data),
    onError: (error: unknown) => {
      const isNotConfigured =
        axios.isAxiosError(error) && error.response?.status === 422;

      showToast({
        title: t("common.notifications.createError.title"),
        description: isNotConfigured
          ? t("common.notifications.createError.notConfigured")
          : t("common.notifications.createError.description"),
        status: "error",
        "data-cy": isNotConfigured
          ? "toast-design-element-not-configured-error"
          : "toast-design-element-create-error",
      });
    },
  });
};
